import React from 'react';
import PropTypes from 'prop-types';

const LogoutPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M19 12.8H8.219c-.397 0-.719.358-.719.8V19c0 .44.322.8.719.8H19V27c0 .552-.45 1-1.007 1H6.007A1.003 1.003 0 0 1 5 27V5c0-.552.45-1 1.007-1h11.986C18.55 4 19 4.447 19 5v7.8zm2.75 1.533l-.003-2.68c0-.367.308-.653.688-.653.215 0 .417.085.547.25l6.878 4.349a.65.65 0 0 1 0 .806l-6.878 4.348c-.23.293-.661.324-.963.1a.609.609 0 0 1-.272-.503l.002-2.184H9.687A.677.677 0 0 1 9 17.5V15c0-.368.308-.667.687-.667H21.75z"
    />
  );
};

LogoutPath.propTypes = {
  fill: PropTypes.string,
};

export default LogoutPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/logout.jsx